export default "__VITE_ASSET__Dscv9CZN__"